/**
 * Checks if a string contains any currency symbols or currency codes
 * @param {string} str - The string to check
 * @returns {boolean} - Returns true if currency symbol/code is found, false otherwise
 */
export function hasCurrencySymbol(str) {
  if (!str || typeof str !== "string") return false;

  // Common currency symbols
  const currencySymbols = [
    "$",
    "€",
    "£",
    "¥",
    "₹",
    "₽",
    "₩",
    "₪",
    "₦",
    "₨",
    "₱",
    "₡",
    "₵",
    "₴",
    "₺",
    "₮",
    "₾",
    "₿",
    "฿",
    "₫",
    "₭",
    "₲",
    "₳",
    "₸",
    "₼",
    "₥",
    "₰",
    "¢",
    "₢",
    "₣",
    "₤",
    "₧",
    "₶",
    "﷼",
  ];

  // Common currency codes (3-letter ISO codes and popular abbreviations)
  const currencyCodes = [
    "USD",
    "EUR",
    "GBP",
    "JPY",
    "CNY",
    "INR",
    "AUD",
    "CAD",
    "CHF",
    "HKD",
    "SGD",
    "SEK",
    "KRW",
    "NOK",
    "NZD",
    "MXN",
    "ZAR",
    "BRL",
    "RUB",
    "TRY",
    "AED",
    "SAR",
    "THB",
    "IDR",
    "MYR",
    "PHP",
    "VND",
    "EGP",
    "PKR",
    "NGN",
    "ILS",
    "CLP",
    "COP",
    "ARS",
    "PLN",
    "CZK",
    "HUF",
    "RON",
    "DKK",
    "BGN",
    "RMB",
    "US",
    "GP",
    "AU",
    "UK",
    "EU",
    "CA",
    "CN",
    "JP",
    "KR",
    "SG",
    "YEN",
    "YUAN",
    "RUPEE",
    "PESO",
    "DOLLAR",
    "POUNDS",
    "EUROS",
    "WON",
  ];

  // Check for currency symbols
  for (const symbol of currencySymbols) {
    if (str.includes(symbol)) return true;
  }

  // Check for currency codes (case-insensitive)
  const upperStr = str.toUpperCase();
  for (const code of currencyCodes) {
    // Use word boundary check to avoid false positives
    const regex = new RegExp(
      `\\b${code}\\b|${code}(?=[^A-Z])|(?<=[^A-Z])${code}`
    );
    if (regex.test(upperStr)) return true;
  }

  return false;
}
